// import Rules from './Rules';

export default {
  priority: 100,
  path: 'rules',
  permissions: ['RequestRules@index'],
  // component: Rules,
  component: load(() => import(/* webpackChunkName: "Requests-Rules" */ './Rules')),
  name: app.translate('routes.home.requests.Rules'),
  icon: 'gavel',
  drawer: false,
};


